import Vue from 'vue';
import _ from 'lodash';
import dottie from 'dottie';
import auth from './auth';

const state = {
  infosheets: {},
  infosheetList: [],
  roomId: null,
};

const actions = {
  FETCH_INFOSHEETS: async ({ commit }, { kuzzle, index }) => {
    if (!index) {
      return;
    }
    let infosheets = await kuzzle.query({
      controller: 'document',
      action: 'search',
      index: index,
      collection: 'infosheets',
      scroll: '1m',
      size: 1000,
      loggedAsUser:
        auth.state.currentUser && auth.state.currentUser.loggedAsUser,
    });

    commit('RESET_INFOSHEETS');

    infosheets.result.hits.forEach((h) => {
      commit('ADD_INFOSHEET', h);
    });
    console.log('fetch infosheets Ok');
  },
  SUBSCRIBE: async ({ commit }, { kuzzle, index }) => {
    if (!index) {
      return;
    }
    const roomId = await kuzzle.realtime.subscribe(
      index,
      'infosheets',
      {
        loggedAsUser:
          auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      },
      (notification) => {
        switch (notification.action) {
          case 'update':
            //notification.result._source._index = index;
            commit('UPDATE_INFOSHEET', {
              infosheetId: notification.result._id,
              infosheetPayload: notification.result._source,
            });

            break;
          case 'delete':
            commit('DELETE_INFOSHEET', notification.result._id);
            break;
          case 'create':
            //notification.result._source._index = index;

            commit('ADD_INFOSHEET', notification.result);
            break;
          case 'mUpdate':
            //notification.result._source._index = index;
            commit('UPDATE_INFOSHEET', {
              infosheetId: notification.result._id,
              infosheetPayload: notification.result._source,
            });
            break;
        }
      },
      { scope: 'all' }
    );
    commit('SET_ROOM_ID', roomId);
    console.log('subscribe ok');
  },
  UNSUBSCRIBE: async ({ commit, state }, kuzzle) => {
    if (state.roomId) {
      await kuzzle.realtime.unsubscribe(state.roomId);
    }
    commit('SET_ROOM_ID', null);
  },
  CREATE_INFOSHEET: async ({}, { infosheetPayload, kuzzle, index }) => {
    if (!index) {
      return;
    }
    console.log('ACTION CREATE', index, infosheetPayload);
    let newInfosheet = await kuzzle.query({
      controller: 'document',
      action: 'create',
      index: index,
      collection: 'infosheets',
      loggedAsUser:
        auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      body: infosheetPayload,
    });

    return newInfosheet.result;
  },
  DELETE_INFOSHEET: async ({}, { infosheetId, index, kuzzle }) => {
    if (!index) {
      return;
    }
    await kuzzle.document.delete(index, 'infosheets', infosheetId);
    //commit('DELETE_INFOSHEET', infosheetId);
  },
  UPDATE_INFOSHEET: async (
    {},
    { infosheetId, infosheetPayload, kuzzle, index }
  ) => {
    console.log('action update infosheet', infosheetId, infosheetPayload);

    await kuzzle.document.update(
      index,
      'infosheets',
      infosheetId,
      infosheetPayload
    );
    console.log('after document update');
  },
  TRANSLATE_INFOSHEETS: async (
    {},
    { index, listInfosheetsIds, originLanguage, targetLanguage, kuzzle }
  ) => {
    console.log('action TRANSLATE_INFOSHEETS');
    const res = await kuzzle.query({
      controller: 'translate',
      action: 'document',
      body: {
        index: index,
        collection: 'infosheets',
        docId: listInfosheetsIds,
        targetLang: targetLanguage,
        originLang: originLanguage,
      },
    });
  },
};

const mutations = {
  RESET_INFOSHEETS: (state) => {
    state.infosheets = {};
    state.infosheetList = [];
  },
  ADD_INFOSHEET: (state, infosheet) => {
    Vue.set(state.infosheets, infosheet._id, infosheet._source);
    state.infosheetList = [...state.infosheetList, infosheet._id];
  },

  UPDATE_INFOSHEET: (state, { infosheetId, infosheetPayload }) => {
    Vue.set(state.infosheets, infosheetId, infosheetPayload);
  },
  TRANSLATE_INFOSHEETS: (state, { infosheetId, pathPayload }) => {
    console.log('mute TRANSLATE_INFOSHEETS');
    Vue.set(state.infosheets, infosheetId, pathPayload);
  },
  DELETE_INFOSHEET: (state, infosheetId) => {
    if (!state.infosheets[infosheetId]) {
      return;
    }
    Vue.delete(state.infosheets, infosheetId);
  },
  SET_ROOM_ID: (state, roomId) => {
    state.roomId = roomId;
  },
};

const getters = {
  getInfosheetsByIds: (state) => {
    return (infosheetsIds) => {
      return Object.fromEntries(
        Object.entries(state.infosheets).filter(([k, v]) =>
          infosheetsIds.includes(k)
        )
      );
    };
  },
  getInfosheet: (state) => {
    return (infosheetName) => {
      if (!Object.keys(state.infosheets).includes(infosheetName)) {
        return null;
      }
      return state.infosheets[infosheetName];
    };
  },
  getInfosheetById: (state) => {
    return (infosheetId) => {
      if (!Object.keys(state.infosheets).includes(infosheetId)) {
        return null;
      }
      return state.infosheets[infosheetId];
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
